export const productResourcePrice = (resource) => {
  if (typeof resource.price === 'object') {
    return parseFloat(Object.values(resource.price)[0].toString())
  }
  console.log('types: ', typeof resource.price, typeof resource.price_without_currency)
  return parseFloat(resource.price_without_currency) || parseFloat(resource.price) || 0.0
}
